import { FunctionComponent, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { APP_MIN_WIDTH, APP_MIN_HEIGHT } from '@cbridge-utils/app';

const LayoutBox = styled(Box)({
  position: 'relative',
  display: 'flex',
  overflow: 'hidden',
  height: '100%',
  width: '100%',
  minWidth: APP_MIN_WIDTH,
  minHeight: APP_MIN_HEIGHT,
});

export const Layout: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  return <LayoutBox>{children}</LayoutBox>;
};
